var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X",
    clipPath: "url(#clip0_3898_13921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.775 12.5L24.2 5.075C25.02 4.255 25.02 2.925 24.2 2.105L23.21 1.115C22.39 0.295 21.06 0.295 20.24 1.115L12.815 8.54L5.39 1.115C4.57 0.295 3.24 0.295 2.42 1.115L1.4275 2.105C0.6075 2.925 0.6075 4.255 1.4275 5.075L8.8525 12.5L1.4275 19.925C0.6075 20.745 0.6075 22.075 1.4275 22.895L2.4175 23.885C3.2375 24.705 4.5675 24.705 5.3875 23.885L12.8125 16.46L20.2375 23.885C21.0575 24.705 22.3875 24.705 23.2075 23.885L24.1975 22.895C25.0175 22.075 25.0175 20.745 24.1975 19.925L16.7725 12.5H16.775Z",
    fill: "#E40000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3898_13921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.b57a354f18fb3efd625100141e3e8fd7.svg";
export { ForwardRef as ReactComponent };